module.exports = __webpack_public_path__ + "static/media/9DESA19.5e31f507.jpg";